import type { ZoneApiResponse, MappedZone } from '@/components/zones/types'
import { ZONE_COLORS } from '@/constants/zones'

const mapZone = (zone: ZoneApiResponse): MappedZone => {
	return {
		id: zone.id,
		name: zone.name,
		type: zone.type,
		isSubzone: zone.isSubzone.toString(),
		parentZoneId: zone.parentZoneId.toString(),
		points: zone.points || '',
		addressCount: zone.addressCount.toString(),
		customersCount: zone.customersCount.toString(),
		penetrationRate: zone.customersCount ? ((zone.customersCount / zone.addressCount) * 100).toFixed(2) : '0.00',
		leadsCount: zone.leadsCount.toString(),
		prospectCount: zone.prospectCount.toString(),
		color: ZONE_COLORS[Math.floor(Math.random() * ZONE_COLORS.length)],
		constructionEstimates: zone.constructionEstimates?.map(estimate => ({
			id: estimate.estimateId,
			title: estimate.title,
			text: estimate.text || ''
		})) || []
	}
}
export { mapZone }
